export const getProductBysubCategory = (subcategoria: string) => {
    return `query MyQuery {
      categoria(where: {nombre: "${subcategoria}"}) {
        producto {
          nombre
          descripcionCorta
          descripcion {
            text
          }
          imagen {
            url
            size
            width
            height
          }
          especimen
          formato
          marca
          precioLista
          precioUnitario
          presentacion
          sku
          categoria {
            nombre
          }
        }
      }
    }`
  }
  
  export const getProductByCategory = (catalog?: string) => {
  console.log('catalog :', catalog);
    let setCategories = catalog == '' ? 'categoriaPrincipals ' : `categoriaPrincipals(where: {nombre: "${catalog}"})`;
    console.log('setCategories :', setCategories);
    return `
    query {
      ${setCategories} {
        nombre
        categoria {
          nombre
          producto {
            nombre
            descripcionCorta
            descripcion {
              text
            }
            imagen {
              url
              size
              width
              height
            }
            especimen
            formato
            marca
            precioLista
            precioUnitario
            presentacion
            sku
            categoria {
              nombre
            }
          }
        }
      }
    }`;
  }
  

export const getProductBySku = (sku: string) => {
    return `query {
        producto(where: {sku: "${sku}"}) {
            descripcion {
                text
                html
            }
            especimen
            formato
            id
            imagen {
            fileName
            mimeType
            size
            url
            width
            height
            }
            marca
            nombre
            precioLista
            precioUnitario
            presentacion
            categoria {
            nombre
            }
            descripcionCorta
            sku
        }
      }
        `
}